/* eslint-disable */
export const GenericsProductItems = [
  {
    "srno": 1,
    "productID": "1004",
    "rLDProduct_Dev": "Gaster (Japan) / Pepcid (UK) / Pepdul (EU)",
    "productName": "Famotidine Tablets (10 mg, 20 mg, 40 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved By NMPA. Filed in EU and UK",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 2,
    "productID": "1001",
    "rLDProduct_Dev": "Nimotop (EU)",
    "productName": "Nimodipine Tablets (30 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Under Review at NMPA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 3,
    "productID": "1002",
    "rLDProduct_Dev": "Dectanyl (EU)",
    "productName": "Dexamethasone Acetate Tablets (0.5 mg , 0.75 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Under Review at NMPA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 4,
    "productID": "1005",
    "rLDProduct_Dev": "Plaquenil (USA)",
    "productName": "Hydroxychloroquine Sulphate Tablets (200 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved By USFDA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 5,
    "productID": "1010",
    "rLDProduct_Dev": "Zyvox (EU)",
    "productName": "Linezolid Tablets (600 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved By TGA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": false
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 6,
    "productID": "1007",
    "rLDProduct_Dev": "Benicar HCT",
    "productName": "Olmesartan + HCTZ Tablets (20 + 12.5, 40 + 12.5, 40 + 25 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Under Review by TGA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": false
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 7,
    "productID": "1009",
    "rLDProduct_Dev": "Prochlorparazine Tablets (USA)",
    "productName": "Prochlorparazine Maleate Tablets (5 mg and 10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Under Review by USFDA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 8,
    "productID": "1011",
    "rLDProduct_Dev": "USL (USA), Largactil (EU)",
    "productName": "Chlorpromazine Hydrochloride Tablets (10 mg, 25 mg, 50 mg, 100 mg, 200 mg )",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Under Review by EU",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 9,
    "productID": "1015",
    "rLDProduct_Dev": "Imdur (EU)",
    "productName": "Isosorbite Mononitrate Sustained Release Tablets (60 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "To be done",
    "technologyTransfer": "To be done",
    "remark": "To be decided",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 10,
    "productID": "1006",
    "rLDProduct_Dev": "Lyrica (EU)",
    "productName": "Pregabalin Capsules (25, 50, 75, 100, 150, 200, 225, & 300 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved by TGA. Under filing EU",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": false
      },
      {
        "key": "S.E. Asia",
        "value": false
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 11,
    "productID": "1007",
    "rLDProduct_Dev": "Xeljanz (USA)",
    "productName": "Tofacitinib Oral solution (1mg/ml)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "NA",
    "technologyTransfer": "Done",
    "remark": "Under Review by USFDA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 12,
    "productID": "1022",
    "rLDProduct_Dev": "Coarsucam (UK)",
    "productName": "Artesunate and Amodiaquine tablets (25/67.5, 50/135, 100/270 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for TT for WHO Submission",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 13,
    "productID": "1022",
    "rLDProduct_Dev": "Malafan (UK))",
    "productName": "Sulfadoxine and Pyrimethamine tablets (500/25 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for TT for WHO Submission",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 14,
    "productID": "1008",
    "rLDProduct_Dev": "Dulcolax DR Tablets (EU)",
    "productName": "Bisacodyl Enteric Coated Tablets (5 mg)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "To be done",
    "technologyTransfer": "To be done",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 15,
    "productID": "1014",
    "rLDProduct_Dev": "Folic Acid Tablets (EU)",
    "productName": "Folic Acid Tablets 5 mg",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "NA",
    "technologyTransfer": "Done",
    "remark": "Filed with MHRA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 16,
    "productID": "1014",
    "rLDProduct_Dev": "Lasix (EU)",
    "productName": "Furosemide Tablets (10,20,40 mg)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "Ongoing",
    "technologyTransfer": "Done",
    "remark": "Pivotal BE Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 17,
    "productID": "1018",
    "rLDProduct_Dev": "Riamet (EU)",
    "productName": "Artemether + Lumefantine (20+120 mg and 80+480 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Planned",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer. Pilot BE Successful.",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": false
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 18,
    "productID": "1019",
    "rLDProduct_Dev": "Zytiga (USA/EU)",
    "productName": "Abiraterone Acetate Tablets 250 and 500 mg",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 19,
    "productID": "1017",
    "rLDProduct_Dev": "Glumetza (USA) / Glucophage (EU)",
    "productName": "Metformin ER Tablets (500 and 1000 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Dossier Filed. Ready for Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 20,
    "productID": "2026",
    "rLDProduct_Dev": "Colonis (UK)",
    "productName": "Melatonin Oral solution (1mg/ml)",
    "productDevStatus": "Done",
    "pilotBE": "NA",
    "scaleUp": "Done",
    "pivotalBE": "NA",
    "technologyTransfer": "Done",
    "remark": "Under Review by MHRA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 21,
    "productID": "2026",
    "rLDProduct_Dev": "Xeljanz (USA / EU)",
    "productName": "Tofacitinib Immediate Release Tablets (5 and 10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Ongoing",
    "technologyTransfer": "Pending",
    "remark": "EB batches ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 22,
    "productID": "2007",
    "rLDProduct_Dev": "Famo PFOS (Lupin)",
    "productName": "Famotidine Powder For Oral Suspension 40mg/ml",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Done",
    "technologyTransfer": "Done",
    "remark": "Approved by USFDA",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 23,
    "productID": "3019",
    "rLDProduct_Dev": "Clarityn (EU)",
    "productName": "Loratidine Tablets (10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Done",
    "pivotalBE": "Ongoing",
    "technologyTransfer": "Pending",
    "remark": "Pivotal BE Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 24,
    "productID": "3021",
    "rLDProduct_Dev": "ZINPASS EZE (BRAZIL),",
    "productName": "Rosuvastatin Calcium and Exetimibe Tablets (40+10, 20+10 and 10 + 10 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Done",
    "scaleUp": "Ongoing",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Tech Transfer",
    "avaliableIn": [
      {
        "key": "USA",
        "value": false
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 25,
    "productID": "3026",
    "rLDProduct_Dev": "Hiprex (EU/ UK), (USA - Aurobindo)",
    "productName": "Methanamine Hippurate Tablets (1000 mg)",
    "productDevStatus": "Done",
    "pilotBE": "N/A",
    "scaleUp": "Ongoing",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Tech Trasnfer Ongoing",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": false
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  },
  {
    "srno": 26,
    "productID": "3027",
    "rLDProduct_Dev": "Kerendia (USA/ EU)",
    "productName": "Finerenone Tablets (10, 20 and 40 mg)",
    "productDevStatus": "Done",
    "pilotBE": "Planned",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready For Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": false
      }
    ]
  },
  {
    "srno": 27,
    "productID": "1028",
    "rLDProduct_Dev": "Loxonin (Brazil)",
    "productName": "Loxoprofen Sodium Dihydrate Tablets 60mg",
    "productDevStatus": "Done",
    "pilotBE": "Pending",
    "scaleUp": "Pending",
    "pivotalBE": "Pending",
    "technologyTransfer": "Pending",
    "remark": "Ready for Pilot BE",
    "avaliableIn": [
      {
        "key": "USA",
        "value": true
      },
      {
        "key": "EU",
        "value": true
      },
      {
        "key": "China",
        "value": true
      },
      {
        "key": "Australia",
        "value": true
      },
      {
        "key": "S.E. Asia",
        "value": true
      },
      {
        "key": "Other",
        "value": true
      }
    ]
  }
];
